import { OrderPosition } from "./OrderPosition";

export class PairPositions {
  abovePositions: Array<OrderPosition> = [];
  belowPositions: Array<OrderPosition> = [];
  constructor(public pairName: string) {}

  addPosition(position: OrderPosition) {
    if (position.above) {
      this.abovePositions.unshift(position);
    } else {
      this.belowPositions.push(position);
    }
  }

  clear() {
    this.abovePositions = [];
    this.belowPositions = [];
  }

  public getAboveSortedPositions(): Array<OrderPosition> {
    return this.abovePositions;
  }
  public getBelowSortedPositions(): Array<OrderPosition> {
    return this.belowPositions;
  }
}
